import React, { useState } from 'react';
import { Box, Button, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useLanguage } from '../i18n/LanguageContext';
import { useAuth } from '../context/AuthContext';
import { SetupScreen } from './SetupScreen';
import { MAX_WIDTH } from '../App';

export const HousePicker: React.FC = () => {
  const { t } = useLanguage();
  const { houses, switchHouse } = useAuth();
  const [addingHouse, setAddingHouse] = useState(false);

  if (addingHouse) return <SetupScreen />;

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '100dvh',
      pt: 'env(safe-area-inset-top)', px: 3,
    }}>
      <Box sx={{ width: '100%', maxWidth: MAX_WIDTH }}>
        <Typography variant="h4" fontWeight="bold" mb={3}>{t.housePickerTitle}</Typography>
        <List sx={{ mb: 2 }}>
          {houses.map(house => (
            <ListItemButton
              key={house.id}
              onClick={() => switchHouse(house.id)}
              sx={{ borderRadius: 2, mb: 1, bgcolor: 'background.paper' }}
            >
              <ListItemText primary={house.clientId} secondary={house.domain} />
            </ListItemButton>
          ))}
        </List>
        <Button fullWidth variant="outlined" startIcon={<Add />} onClick={() => setAddingHouse(true)}>
          {t.housePickerAddHouse}
        </Button>
      </Box>
    </Box>
  );
};
